import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { SubmissionAccountPopupComponent } from './submission-account-popup/submission-account-popup.component';
import { GlobalComponent } from '@app/core/Models/common/global-component';
import { GetSubmitMainGridDetails, ShowStatusMessage, SubmitReportDownloadHTML, SubmitReportDownloadPDF } from '@app/core/Store';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { ConfirmationType, Modules, NotificationDetails, NotificationHeader, RoutingPath } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { ConfirmationBoxComponent, MessageBoxComponent } from '@app/modules/common';

@Component({
  selector: 'app-submission-grid',
  templateUrl: './submission-grid.component.html',
  styleUrls: ['./submission-grid.component.scss']
})
export class SubmissionGridComponent implements OnInit {
  displayedSubmitColumns: string[] = [ 'from', 'to', 'subdate', 'status'];
  dataSubmitSource: any[];
  selectedRowIndex = -1;
  periodicDateList: any;
  accountingId: any;
  fileDetails: any;

  constructor(
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private globalComponent: GlobalComponent,
    private store: Store,
    public router: Router,
    public commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.setPeriodDate();
  }

  getListSavedFiles(): void {
    this.spinner.show();
  }

  openDialog() {
    const dialogRef = this.dialog.open(SubmissionAccountPopupComponent, {
      disableClose: true,
      panelClass: 'sub-dialog-box' 
    });
  
    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
  }

  setPeriodDate(): void {
    this.periodicDateList = this.globalComponent.getFinancialPeriod();
    const defaultPeriodName = localStorage.getItem('defaultFinancialPeriod');

    if (defaultPeriodName) {
      const foundPeriod = this.periodicDateList.find(
        (p) => p.name.trim() === defaultPeriodName.trim()
      );
      if (foundPeriod) {
        this.accountingId = foundPeriod.id;
      } else {
        this.accountingId = this.periodicDateList[0]?.id;
      }
    } else {
      this.accountingId = this.periodicDateList[0]?.id;
    }

    if (this.accountingId) {
      this.getSubmitMainGridDetail();
    }
  }

  getSubmitMainGridDetail(): void{
    this.spinner.show();
    const selectedPeriod = this.periodicDateList.find(
      (p) => p.id === this.accountingId
    );
    if (selectedPeriod) {
      localStorage.setItem('defaultFinancialPeriod', selectedPeriod.name.trim());
    }

    this.store.dispatch(new GetSubmitMainGridDetails(this.accountingId)).pipe().subscribe(
      (response: any) => {
        this.dataSubmitSource = response?.SubmitCompanyHouse?.submissionDetails;
      }
    );
  }

  redirectToSubmit(id: any, submitId: any): void{
    this.router.navigate([RoutingPath.submitCompaniesHouse, { id: id, periodId: this.accountingId, submitId: submitId }]);
  }

  downloadReport(id: any): void{
    this.spinner.show();
    this.store.dispatch(new SubmitReportDownloadHTML(this.accountingId, id)).pipe().subscribe();
  }

  downloadReportAsPDF(id: any): void{
    this.spinner.show();
    this.store.dispatch(new SubmitReportDownloadPDF(this.accountingId, id)).pipe().subscribe();
  }

  onDeleteClick(id: any): void {
    this.dialog.open(ConfirmationBoxComponent, {
      data: {
        ids: id,
        type: ConfirmationType.Delete,
        moduleId: Modules.submit,
        totalNumberOfRecordSelected: 1,
        headerText: NotificationHeader.deleteConfirmation,
        detailText: NotificationDetails.deleteAllDetailText,
      },
    })
    .afterClosed()
    .subscribe((result) => {
      if (result) {
      this.getSubmitMainGridDetail();
      }
    });
  }

  showData(id:any):void{

     this.store.dispatch(new ShowStatusMessage(id)).pipe().subscribe(
          (response: any) => {
              this.displayMessage(response.SubmitCompanyHouse?.submitStatusDetails?.message, response.SubmitCompanyHouse?.submitStatusDetails?.status);
               this.getSubmitMainGridDetail();
          }
        );
  
  }

  displayMessage(message: any, isSuccess: any): void{
    this.dialog
      .open(MessageBoxComponent, {
        data: {
          ConfirmationType: isSuccess ? 'success' : 'error',
          headerText: NotificationHeader.confirmation,
          detailText: message,
        },
      })
      .afterClosed()
      .subscribe();
  }
}